import useMediaQuery from "@mui/material/useMediaQuery";
import { Button } from "antd";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as AppStoreIcon } from "../../assets/images/app-store.svg";
import { ReactComponent as GooglePlayIcon } from "../../assets/images/google-play-badge.svg";
import { ReactComponent as InstgramIcon } from "../../assets/images/instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/images/linkedin.svg";
import { ReactComponent as TwitterXIcon } from "../../assets/images/twitter-x.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/images/youtube.svg";
import config from "../../config";
import FooterWrapper from "./style";

const Footer = () => {
  const { t } = useTranslation();
  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.MOBILE_MAX_WIDTH}px)`
  );

  return (
    <FooterWrapper className="d-flex flex-column">
      <div className="row footer px-3 px-md-5 d-flex flex-column-reverse flex-md-row">
        <div className={`${matches ? "col-3" : "col-12"}`}>
          <div
            className={`${matches ? "social mb-lg-2" : "social-responsive"}`}
          >
            <Button
              type={"link"}
              href="https://www.instagram.com/MoDEEJO/"
              target="_blank"
              icon={<InstgramIcon />}
            />
            <Button
              type={"link"}
              href="https://www.linkedin.com/company/ministry-of-digital-economy-entrepreneurship-jordan-%D9%88%D8%B2%D8%A7%D8%B1%D8%A9-%D8%A7%D9%84%D8%A7%D9%82%D8%AA%D8%B5%D8%A7%D8%AF-%D8%A7%D9%84%D8%B1%D9%82%D9%85%D9%8A-%D9%88%D8%A7%D9%84%D8%B1%D9%8A%D8%A7%D8%AF%D8%A9-%D8%A7%D9%84%D8%A3%D8%B1%D8%AF%D9%86/?originalSubdomain=jo"
              target="_blank"
              icon={<LinkedinIcon />}
            />
            {/* <Button type={"link"} href="#" icon={<SnapschatIcon />} /> */}
            <Button
              type={"link"}
              href="https://twitter.com/jordanegov"
              target="_blank"
              icon={<TwitterXIcon />}
            />
            <Button
              type={"link"}
              href="https://www.youtube.com/channel/UCMjMV4oLpolrB3uAnTh_sWg"
              target="_blank"
              icon={<YoutubeIcon />}
            />
          </div>
          <div className={`${matches ? "stores" : "stores-responsive"}`}>
            <Button
              type={"link"}
              href="https://apps.apple.com/jo/app/%D8%AF%D8%A7%D8%A6%D8%B1%D8%A9-%D8%A7%D9%84%D8%A3%D8%B1%D8%A7%D8%B6%D9%8A-%D9%88%D8%A7%D9%84%D9%85%D8%B3%D8%A7%D8%AD%D8%A9/id6472173737"
              icon={<AppStoreIcon />}
            />
            <Button
              type={"link"}
              href="https://play.google.com/store/apps/details?id=com.infograph.landsapplication&pli=1"
              icon={<GooglePlayIcon />}
            />
            {/* <Link to="#">
              <img src={googlePlayIcon} />
            </Link> */}
          </div>
        </div>

        <div
          className={`justify-content-around navigation-menu ${
            matches ? "d-flex col-7" : " col-10"
          }`}
        >
          <div className={`d-flex flex-column ${matches ? "" : " mx-10"}`}>
            <a
              href="https://portal.jordan.gov.jo/wps/portal"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.myGov")}
            </a>

            <a
              href="https://portal.jordan.gov.jo/wps/portal/Home/MediaCenter"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.mediaCenter")}
            </a>

            <a
              href="https://portal.jordan.gov.jo/wps/portal/Home/Reports"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.reports")}
            </a>
          </div>
          <div className={`d-flex flex-column ${matches ? "" : " mx-10"}`}>
            <a href="#">{t("footer.aboutJordan")}</a>
            <a
              href="https://portal.jordan.gov.jo/wps/portal/Home/FAQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.faq")}
            </a>

            <a
              // href="https://portal.jordan.gov.jo/wps/portal/Home/CMU"
              href="https://jordan.gov.jo/ar/custompages/onyourservice"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.inServe")}
            </a>
          </div>

          <div className={`d-flex flex-column ${matches ? "" : " mx-10"}`}>
            <a
              href="https://portal.jordan.gov.jo/wps/portal/Home/CMU/CMU#/complaintVerification?type=AskGovernment"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.nationalCallCenter")}
            </a>

            <a href="tel:0096265008080">065008080</a>

            <a href="#">{t("footer.more")}</a>
          </div>
        </div>
      </div>

      <div className="fm-kufi-regular copywirte">
        {t("footer.copywrite", { year: moment().format("YYYY") })}{" "}
        {/* <h6 className="text-white text-decoration-none mt-3">
          {t("footer.developedBy")}{" "}
          <a href="https://agiletz.com/" target="_blank" rel="noreferrer" className="text-white text-decoration-none" >
            {t("footer.developer")}
          </a>
        </h6> */}
      </div>
    </FooterWrapper>
  );
};

export default Footer;
